<template>
  <slot></slot>
</template>

<script>
/**
 * Component load danh sách script bên ngoài theo thứ tự (tuần tự, không song song).
 * Mỗi script chờ cái trước load xong mới load tiếp — đảm bảo thứ tự phụ thuộc.
 * Sau khi tất cả load xong thì gọi callback onLoaded.
 *
 * Port từ MISA.SALAV2.FE — dùng cho MISA Platform (MPL): MISACore, QuickLauncher, MWSClient
 */
export default {
  name: 'MsDependencyLibs',
  props: {
    libs: {
      type: Array,
      default: () => [],
    },
    onLoaded: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      libCountLoaded: 0,
    };
  },
  watch: {
    libCountLoaded(val) {
      if (val >= this.resolvedLibs.length) {
        this.onLoaded && this.onLoaded();
      }
    },
  },
  computed: {
    resolvedLibs() {
      return (this.libs || []).filter(Boolean);
    },
  },
  async created() {
    for (let i = 0; i < this.resolvedLibs.length; i++) {
      await this._loadScript(this.resolvedLibs[i]);
      this.libCountLoaded = this.libCountLoaded + 1;
    }
  },
  methods: {
    _loadScript(scriptSrc) {
      return new Promise(resolve => {
        if (document.querySelector(`script[src="${scriptSrc}"]`)) {
          resolve(true);
          return;
        }
        const script = document.createElement('script');
        script.src = scriptSrc;
        script.type = 'text/javascript';
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
      });
    },
  },
};
</script>
